import { cn } from './cn.js';
/** Dashboard tile — every number links somewhere (docs/03 §26.3). */
export function Stat({
  label,
  value,
  tone = 'neutral',
  hint,
  onClick,
}: {
  label: string;
  value: string | number;
  tone?: 'neutral' | 'red' | 'green' | 'amber';
  hint?: string;
  onClick?: () => void;
}) {
  const t = {
    neutral: 'text-grey-900',
    red: 'text-red-600',
    green: 'text-green-600',
    amber: 'text-[#8a6d00]',
  }[tone];
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex flex-col items-start rounded-lg border bg-white px-4 py-3 text-left shadow-sm transition hover:border-blue-500 hover:shadow',
        !onClick && 'cursor-default hover:border-grey-300 hover:shadow-sm',
      )}
    >
      <span className="text-xs text-grey-500">{label}</span>
      <span className={cn('mt-1 text-2xl font-semibold tabular-nums', t)}>{value}</span>
      {hint && <span className="mt-0.5 text-[11px] text-grey-500">{hint}</span>}
    </button>
  );
}
